import React from 'react';

const User = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6667 4.66669C10.6667 6.13945 9.47273 7.33336 7.99999 7.33336C6.52723 7.33336 5.33333 6.13945 5.33333 4.66669C5.33333 3.19393 6.52723 2.00002 7.99999 2.00002C9.47273 2.00002 10.6667 3.19393 10.6667 4.66669Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99999 9.33336C5.42267 9.33336 3.33333 11.4227 3.33333 14H12.6667C12.6667 11.4227 10.5773 9.33336 7.99999 9.33336Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default User;
